
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexC90y7SG1T2BsIMkVnsLrCEhogkQB5J8_zwakFSGGEdIMeta } from "/app/app/src/pages/index.vue?macro=true";
import { default as indexM6bkInLp_2pHbnCl7FNt9Kko7hh7IqIPg4_Z7JlqzCsMeta } from "/app/app/src/pages/print/index.vue?macro=true";
import { default as indexhYQRJU7UtmCSyCuiMFF0RWe6_oyp2GkblSqlsdmGi_YMeta } from "/app/app/src/pages/print/index.ts?macro=true";
import { default as printBBXlEd3r58up8YTNj2HQbOztOz_ombUQQtoANEZTYqMMeta } from "/app/app/src/pages/print/print.vue?macro=true";
import { default as indexNrQfad0c6_JfHL72Jlkkshw4fID8YmzsOTSwR08VIVkMeta } from "/app/app/src/pages/budgets/index.vue?macro=true";
import { default as index2IySFmSD6BcGqdNrxHe_B2qnss6T7M6o6BXd_4skN9cMeta } from "/app/app/src/pages/profile/index.vue?macro=true";
import { default as indextTdzb8GnalZ41NYh0X6_L7WzERlzEdNDaZdf_agvKfIMeta } from "/app/app/src/pages/promote/index.vue?macro=true";
import { default as indexygdjXJ_bj6gz1Q11O8_90sU3laCyo_nI032pYVC9q6gMeta } from "/app/app/src/pages/checkout/index.vue?macro=true";
import { default as indexDKjtHMbsYEgX0zVfhlVVCEW9Kr_NdBN6B1ISi8_a9nIMeta } from "/app/app/src/pages/my-posts/index.vue?macro=true";
import { default as indexhxcdHq449pQFd7zmCzbpmjTkPn7BjTj7XT5bswkjD1gMeta } from "/app/app/src/pages/[hub-slug]/index.vue?macro=true";
import { default as indexZdy_DIlK5vK8_F1W_0lwt5HGl7BEFunwd94AIoL6aggMeta } from "/app/app/src/pages/auth/login/index.vue?macro=true";
import { default as indexk_icfvWp0fSYdR38wz3GjapvPZh9Btt64talr8Q91o4Meta } from "/app/app/src/pages/onboarding/index.vue?macro=true";
import { default as indexP_qr4yaQBlyu_Cj3H_JBUPwFwb3aPZbrBdUDYOTkJVcMeta } from "/app/app/src/pages/auth/logout/index.vue?macro=true";
import { default as index26EluWV80b2cA0v9UH63YOWrB2AqNVdeKuHT8DH4Ab4Meta } from "/app/app/src/pages/print/_types/index.ts?macro=true";
import { default as indexgl0uLLhhARpfaIohgzJIUWG3BqwhWHvvOjUbZGrFKgEMeta } from "/app/app/src/pages/auth/twitter/index.vue?macro=true";
import { default as indexnZFzaslf6F8eB0IHNHtT0i9KE5EJHHPNaLFhwpvhnEEMeta } from "/app/app/src/pages/auth/welcome/index.vue?macro=true";
import { default as indexP5mmnFVoZ_3mL53hbYft2KRuR9gtuHX5P5ud1EForVYMeta } from "/app/app/src/pages/auth/facebook/index.vue?macro=true";
import { default as indexkYZWQpNmOd487X0U9BAEhL9b8qflduvbwljTA08u_q4Meta } from "/app/app/src/pages/auth/linkedin/index.vue?macro=true";
import { default as index0Bb7jxHWwC_Ya_ub2MZCNMdG0Fxv2gb5MWIdYj6BuzEMeta } from "/app/app/src/pages/auth/register/index.vue?macro=true";
import { default as indexjKUz8pKHvy3JSyRHLQi0xoyYgBLh_iFbu7abMZTFHmIMeta } from "/app/app/src/pages/print/checkout/index.ts?macro=true";
import { default as indexU3GRnBfmwKudFO_QCpaqdlEo0PtFUbUqEllVKhvaE8IMeta } from "/app/app/src/pages/promote/_types/index.ts?macro=true";
import { default as indexoovepY_quEKVJOiXuVio__jbn3rnjLWYbhYwRxTnoBIMeta } from "/app/app/src/pages/auth/instagram/index.vue?macro=true";
import { default as indexLfzdDPNSUtJXSZqnjrSyCosLS_xUjXoBSnD6zAKxI68Meta } from "/app/app/src/pages/oauth2/twitter/index.vue?macro=true";
import { default as indexf_7sJSTg38okeeVbMbCk7QbUzZnCyHwweENxuBQUcMwMeta } from "/app/app/src/pages/welcome-screen/index.vue?macro=true";
import { default as index9OsRO8CoBF1zGw_or6mGzgBBAc2r5LwsTCdmGspcGaAMeta } from "/app/app/src/pages/oauth2/facebook/index.vue?macro=true";
import { default as indexB1uDevV_gQZWEormi7NAv_7MbSI_7mN8T14Mg2If5ksMeta } from "/app/app/src/pages/oauth2/linkedin/index.vue?macro=true";
import { default as indexoXc4fE9SlofTjxV55ZNHXoEQTYQ5yYdOP4y5BhWuYioMeta } from "/app/app/src/pages/oauth2/instagram/index.vue?macro=true";
import { default as checkoutOS6PE2_B2IM0yaoodTWSthE7Qdh7vVtnix56_ii_mrgMeta } from "/app/app/src/pages/print/checkout/checkout.vue?macro=true";
import { default as index6fhJwtU47J8K94k76sh4HrX4CQ6MVAtP8RK_RzoFqLsMeta } from "/app/app/src/pages/promote/_constants/index.ts?macro=true";
import { default as indexHHw5KToABuI6LCIboRTBvMPU4pxVIusF4W9pWZ9eoP8Meta } from "/app/app/src/pages/business-selection/index.vue?macro=true";
import { default as indexIV9ZZL_LqCHEdCkk7rJLx9meZIriWW3H9U8UMeq2a5MMeta } from "/app/app/src/pages/auth/reset-password/index.vue?macro=true";
import { default as indexsU_s4L_IleNPDCSaX1Snaf9Nyb0gWipJKVsOIHSDoSEMeta } from "/app/app/src/pages/auth/create-password/index.vue?macro=true";
import { default as index_nsRgH339kv7U0SFMcT0E4qq6huaKSEtwaaU_6b361UMeta } from "/app/app/src/pages/customizable-content/index.vue?macro=true";
import { default as indexQuIE3JAwmaCWtuheHO0sXk6XFCwGkn1TbgJaowwi7HEMeta } from "/app/app/src/pages/auth/register-account/index.vue?macro=true";
import { default as indexzZbf1L5JGePgLRGFuwm7WRTtnS2B1reMD3pR6UKGGF4Meta } from "/app/app/src/pages/auth/set-new-password/index.vue?macro=true";
import { default as indexbdyZwzu6OLmvCL75KVLPd0wgeN_2MYX4DhGBRrrjGX4Meta } from "/app/app/src/pages/my-customized-content/index.vue?macro=true";
import { default as indexEwHKqsFms037KWhkPr7Fjxn5MAqGrZDqFNfSJ9LFrMkMeta } from "/app/app/src/pages/org/[organization-slug]/index.vue?macro=true";
import { default as indexJl6rUMf0eIliyVgD3g5UWM4sun8J5x6Xh8x7HSuhrTMMeta } from "/app/app/src/pages/[hub-slug]/[content-slug]/index.vue?macro=true";
import { default as indexkG0sbVjbSDwUfT5Fba9PjyPDwnuoJgXfBGCSB98TiXoMeta } from "/app/app/src/pages/auth/resend-welcome-email/index.vue?macro=true";
import { default as payment_45step3TYK7t41sHKukBxHe0nNCA9dauCKNqeecMcr_k18_54Meta } from "/app/app/src/pages/print/checkout/_steps/payment-step.vue?macro=true";
import { default as delivery_45stepF1LdYpIBa_SHDqQ1pLsi_6Ec97lS0nEz4kcF0s_hJqIMeta } from "/app/app/src/pages/print/checkout/_steps/delivery-step.vue?macro=true";
import { default as shipping_45stepmZpeHPAtVCNwefrMOKrPW9qF2Ulq8b9ekD5wY6EUM3QMeta } from "/app/app/src/pages/print/checkout/_steps/shipping-step.vue?macro=true";
import { default as indexwQpnoig1_HX1qvYmuORAYfUaeR7hrqvkwoRSJ5n_PpoMeta } from "/app/app/src/pages/org/[organization-slug]/[hub-slug]/index.vue?macro=true";
import { default as indexu85JPgedKao9aQW3m3HpRUokjMORAvF_A_fD4bAkLfwMeta } from "/app/app/src/pages/customizable-content/[content-slug]/index.vue?macro=true";
import { default as indexkOfNKEAeKmTMRPhad9XikwslpngurLPmRCu6vSzhX1AMeta } from "/app/app/src/pages/org/[organization-slug]/[hub-slug]/[content-slug]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexC90y7SG1T2BsIMkVnsLrCEhogkQB5J8_zwakFSGGEdIMeta || {},
    component: () => import("/app/app/src/pages/index.vue")
  },
  {
    name: indexhYQRJU7UtmCSyCuiMFF0RWe6_oyp2GkblSqlsdmGi_YMeta?.name,
    path: "/print",
    component: () => import("/app/app/src/pages/print/index.ts"),
    children: [
  {
    name: "print",
    path: "",
    meta: indexM6bkInLp_2pHbnCl7FNt9Kko7hh7IqIPg4_Z7JlqzCsMeta || {},
    component: () => import("/app/app/src/pages/print/index.vue")
  }
]
  },
  {
    name: "print-print",
    path: "/print/print",
    component: () => import("/app/app/src/pages/print/print.vue")
  },
  {
    name: "budgets",
    path: "/budgets",
    component: () => import("/app/app/src/pages/budgets/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: index2IySFmSD6BcGqdNrxHe_B2qnss6T7M6o6BXd_4skN9cMeta || {},
    component: () => import("/app/app/src/pages/profile/index.vue")
  },
  {
    name: "promote",
    path: "/promote",
    component: () => import("/app/app/src/pages/promote/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: indexygdjXJ_bj6gz1Q11O8_90sU3laCyo_nI032pYVC9q6gMeta || {},
    component: () => import("/app/app/src/pages/checkout/index.vue")
  },
  {
    name: "my-posts",
    path: "/my-posts",
    meta: indexDKjtHMbsYEgX0zVfhlVVCEW9Kr_NdBN6B1ISi8_a9nIMeta || {},
    component: () => import("/app/app/src/pages/my-posts/index.vue")
  },
  {
    name: "hubslug",
    path: "/:hubslug()",
    component: () => import("/app/app/src/pages/[hub-slug]/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexZdy_DIlK5vK8_F1W_0lwt5HGl7BEFunwd94AIoL6aggMeta || {},
    component: () => import("/app/app/src/pages/auth/login/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: indexk_icfvWp0fSYdR38wz3GjapvPZh9Btt64talr8Q91o4Meta || {},
    component: () => import("/app/app/src/pages/onboarding/index.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    meta: indexP_qr4yaQBlyu_Cj3H_JBUPwFwb3aPZbrBdUDYOTkJVcMeta || {},
    component: () => import("/app/app/src/pages/auth/logout/index.vue")
  },
  {
    name: "print-_types",
    path: "/print/_types",
    component: () => import("/app/app/src/pages/print/_types/index.ts")
  },
  {
    name: "auth-twitter",
    path: "/auth/twitter",
    meta: indexgl0uLLhhARpfaIohgzJIUWG3BqwhWHvvOjUbZGrFKgEMeta || {},
    component: () => import("/app/app/src/pages/auth/twitter/index.vue")
  },
  {
    name: "auth-welcome",
    path: "/auth/welcome",
    meta: indexnZFzaslf6F8eB0IHNHtT0i9KE5EJHHPNaLFhwpvhnEEMeta || {},
    component: () => import("/app/app/src/pages/auth/welcome/index.vue")
  },
  {
    name: "auth-facebook",
    path: "/auth/facebook",
    meta: indexP5mmnFVoZ_3mL53hbYft2KRuR9gtuHX5P5ud1EForVYMeta || {},
    component: () => import("/app/app/src/pages/auth/facebook/index.vue")
  },
  {
    name: "auth-linkedin",
    path: "/auth/linkedin",
    meta: indexkYZWQpNmOd487X0U9BAEhL9b8qflduvbwljTA08u_q4Meta || {},
    component: () => import("/app/app/src/pages/auth/linkedin/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: index0Bb7jxHWwC_Ya_ub2MZCNMdG0Fxv2gb5MWIdYj6BuzEMeta || {},
    component: () => import("/app/app/src/pages/auth/register/index.vue")
  },
  {
    name: "print-checkout",
    path: "/print/checkout",
    component: () => import("/app/app/src/pages/print/checkout/index.ts")
  },
  {
    name: "promote-_types",
    path: "/promote/_types",
    component: () => import("/app/app/src/pages/promote/_types/index.ts")
  },
  {
    name: "auth-instagram",
    path: "/auth/instagram",
    meta: indexoovepY_quEKVJOiXuVio__jbn3rnjLWYbhYwRxTnoBIMeta || {},
    component: () => import("/app/app/src/pages/auth/instagram/index.vue")
  },
  {
    name: "oauth2-twitter",
    path: "/oauth2/twitter",
    meta: indexLfzdDPNSUtJXSZqnjrSyCosLS_xUjXoBSnD6zAKxI68Meta || {},
    component: () => import("/app/app/src/pages/oauth2/twitter/index.vue")
  },
  {
    name: "welcome-screen",
    path: "/welcome-screen",
    meta: indexf_7sJSTg38okeeVbMbCk7QbUzZnCyHwweENxuBQUcMwMeta || {},
    component: () => import("/app/app/src/pages/welcome-screen/index.vue")
  },
  {
    name: "oauth2-facebook",
    path: "/oauth2/facebook",
    meta: index9OsRO8CoBF1zGw_or6mGzgBBAc2r5LwsTCdmGspcGaAMeta || {},
    component: () => import("/app/app/src/pages/oauth2/facebook/index.vue")
  },
  {
    name: "oauth2-linkedin",
    path: "/oauth2/linkedin",
    meta: indexB1uDevV_gQZWEormi7NAv_7MbSI_7mN8T14Mg2If5ksMeta || {},
    component: () => import("/app/app/src/pages/oauth2/linkedin/index.vue")
  },
  {
    name: "oauth2-instagram",
    path: "/oauth2/instagram",
    meta: indexoXc4fE9SlofTjxV55ZNHXoEQTYQ5yYdOP4y5BhWuYioMeta || {},
    component: () => import("/app/app/src/pages/oauth2/instagram/index.vue")
  },
  {
    name: "print-checkout-checkout",
    path: "/print/checkout/checkout",
    component: () => import("/app/app/src/pages/print/checkout/checkout.vue")
  },
  {
    name: "promote-_constants",
    path: "/promote/_constants",
    component: () => import("/app/app/src/pages/promote/_constants/index.ts")
  },
  {
    name: "business-selection",
    path: "/business-selection",
    meta: indexHHw5KToABuI6LCIboRTBvMPU4pxVIusF4W9pWZ9eoP8Meta || {},
    component: () => import("/app/app/src/pages/business-selection/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: indexIV9ZZL_LqCHEdCkk7rJLx9meZIriWW3H9U8UMeq2a5MMeta || {},
    component: () => import("/app/app/src/pages/auth/reset-password/index.vue")
  },
  {
    name: "auth-create-password",
    path: "/auth/create-password",
    meta: indexsU_s4L_IleNPDCSaX1Snaf9Nyb0gWipJKVsOIHSDoSEMeta || {},
    component: () => import("/app/app/src/pages/auth/create-password/index.vue")
  },
  {
    name: "customizable-content",
    path: "/customizable-content",
    component: () => import("/app/app/src/pages/customizable-content/index.vue")
  },
  {
    name: "auth-register-account",
    path: "/auth/register-account",
    meta: indexQuIE3JAwmaCWtuheHO0sXk6XFCwGkn1TbgJaowwi7HEMeta || {},
    component: () => import("/app/app/src/pages/auth/register-account/index.vue")
  },
  {
    name: "auth-set-new-password",
    path: "/auth/set-new-password",
    meta: indexzZbf1L5JGePgLRGFuwm7WRTtnS2B1reMD3pR6UKGGF4Meta || {},
    component: () => import("/app/app/src/pages/auth/set-new-password/index.vue")
  },
  {
    name: "my-customized-content",
    path: "/my-customized-content",
    component: () => import("/app/app/src/pages/my-customized-content/index.vue")
  },
  {
    name: "org-organizationslug",
    path: "/org/:organizationslug()",
    meta: indexEwHKqsFms037KWhkPr7Fjxn5MAqGrZDqFNfSJ9LFrMkMeta || {},
    component: () => import("/app/app/src/pages/org/[organization-slug]/index.vue")
  },
  {
    name: "hubslug-contentslug",
    path: "/:hubslug()/:contentslug()",
    component: () => import("/app/app/src/pages/[hub-slug]/[content-slug]/index.vue")
  },
  {
    name: "auth-resend-welcome-email",
    path: "/auth/resend-welcome-email",
    meta: indexkG0sbVjbSDwUfT5Fba9PjyPDwnuoJgXfBGCSB98TiXoMeta || {},
    component: () => import("/app/app/src/pages/auth/resend-welcome-email/index.vue")
  },
  {
    name: "print-checkout-_steps-payment-step",
    path: "/print/checkout/_steps/payment-step",
    component: () => import("/app/app/src/pages/print/checkout/_steps/payment-step.vue")
  },
  {
    name: "print-checkout-_steps-delivery-step",
    path: "/print/checkout/_steps/delivery-step",
    component: () => import("/app/app/src/pages/print/checkout/_steps/delivery-step.vue")
  },
  {
    name: "print-checkout-_steps-shipping-step",
    path: "/print/checkout/_steps/shipping-step",
    component: () => import("/app/app/src/pages/print/checkout/_steps/shipping-step.vue")
  },
  {
    name: "org-organizationslug-hubslug",
    path: "/org/:organizationslug()/:hubslug()",
    meta: indexwQpnoig1_HX1qvYmuORAYfUaeR7hrqvkwoRSJ5n_PpoMeta || {},
    component: () => import("/app/app/src/pages/org/[organization-slug]/[hub-slug]/index.vue")
  },
  {
    name: "customizable-content-contentslug",
    path: "/customizable-content/:contentslug()",
    component: () => import("/app/app/src/pages/customizable-content/[content-slug]/index.vue")
  },
  {
    name: "org-organizationslug-hubslug-contentslug",
    path: "/org/:organizationslug()/:hubslug()/:contentslug()",
    meta: indexkOfNKEAeKmTMRPhad9XikwslpngurLPmRCu6vSzhX1AMeta || {},
    component: () => import("/app/app/src/pages/org/[organization-slug]/[hub-slug]/[content-slug]/index.vue")
  }
]